<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";


/**
 * Products component
 */
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Layout, PageHeader },
  data() {
    return {
      title: "Productos de Baja",
      items: [
        {
          text: "Administración",
          href: "/",
        },
        {
          text: "Productos de Baja",
          active: true,
        },
      ],
    
    };
  },
  mounted() {
    //** Get data from product api */
    // axios
    //   .get(`http://localhost:8000/api/products`)
    //   .then((res) => {
    //     this.clothsData = res.data.data;
    //   })
    //   .catch((err) => {
    //     return err;
    //   });
  },
  methods: {
   

  

  
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
   
      <div class="col-lg-9">
        <div class="row mb-3">
          <div class="col-xl-4 col-sm-6">
            <div class="mt-2">
              <h5>Productos de Baja</h5>
            </div>
          </div>
       
        </div>
    
     
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
